import React from "react";
import ListView from "../../../shared/components/ListView";
import {EmployeeSearch, EmployeeTableColumns} from "../../../configs/employee";
import {UserRow} from "./UserTable";
import {EmployeeSortTypes} from "../../../configs/sortTypes";
import {EmployeeFilterType} from "../../../configs/filterTypes";

const Content = () => {
  return (
    <ListView
      url="/users/"
      rowElement={UserRow}
      tableColumns={EmployeeTableColumns}
      filterTypes={EmployeeFilterType}
      sortTypes={EmployeeSortTypes}
      textString={EmployeeSearch.searchText}
    />
  );
};

export default Content;
